<app-error-display
  *ngIf="data.type === 'error'; else otherSnackbar"
  [errorMessage]="data.message"
  [isSnackbarError]="true"
  (closeError)="onAction()"
></app-error-display>

<ng-template #otherSnackbar>
  <div
    class="snackbar-content d-flex align-items-center justify-content-between uppercase"
    [ngStyle]="snackbarStyles"
  >
    <div class="d-flex column align-items-center">
      <span>{{ data.message }}</span>
    </div>
    <app-button
      *ngIf="data.actionText"
      variant="default"
      color="starlight"
      sizeType="flexible"
      flexibleSize="sm"
      fontSize="sm"
      (click)="onAction()"
    >
      {{ data.actionText }}
    </app-button>
    <svg-icon
      *ngIf="showCloseIcon"
      src="assets/icons/icon-close.svg"
      (click)="onClose()"
      class="icon-close"
    ></svg-icon>
  </div>
</ng-template>
